<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="客户">
      {{ head.customer.customerNo }}<br />
      {{ head.customer.name }}
    </el-descriptions-item>
    <el-descriptions-item label="联系人信息" span="2">
      {{ head.customerName + " " + head.customerPhoneNumber }}
      <br />
      {{ "联系地址：" + head.customerAddress }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="500px"
        :span-method="objectSpanMethod"
        style="max-width: 830px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              v-if="scope.row.saleSuitId"
            ></CommodityImage>
            <CommodityImage
              :commodity="scope.row.commoditySnapshot"
              :commoditySpec="scope.row.commoditySpecSnapshot"
              v-else
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="saleSuitName"
          label="套装 / 商品信息"
          min-width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.4em">
              <span style="font-size: 1.1em">{{
                scope.row.commoditySnapshot.name
              }}</span
              ><br />
              {{ "分类：" + scope.row.commoditySnapshot.commodityCategory.name
              }}<br />
              {{ "颜色：" + scope.row.commoditySnapshot.color }}<br />
              <div class="fm-margin-top-5" v-if="scope.row.saleSuitId">
                <span style="font-size: 1.1em">{{
                  "套装名称：" + scope.row.saleSuitName
                }}</span
                ><br />
                <div class="fm-flex">
                  套装售价：
                  <fm-amount :amount="scope.row.saleSuitSalePrice"></fm-amount>
                </div>
                {{ "套装购买数量：" + scope.row.saleSuitQuantity }}<br />
                <div class="fm-flex">
                  套装总售价：
                  <fm-amount :amount="scope.row.saleSuitSumAmount"></fm-amount>
                </div>
                <div class="fm-flex">
                  套装折扣金额：
                  <fm-amount
                    :amount="scope.row.saleSuitDisCountAmount"
                  ></fm-amount>
                </div>
                <div class="fm-flex">
                  套装成交价：
                  <fm-amount :amount="scope.row.saleSuitAmount"></fm-amount>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySpecSnapshot.specName"
          label="商品规格"
          min-width="100"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="buyingPrice"
          label="商品零售价"
          width="120"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.itemQuantity + scope.row.commoditySnapshot.unit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemMwAmount"
          label="商品成本"
          width="120"
          align="center"
          header-align="center"
          v-if="
            head.orderApprovalStatusEnum.Name == 'Approval' &&
            $jsTool.currentUserCanSeePrice()
          "
        >
          <el-tooltip
            slot="header"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">商品成本说明</div>
              当前商品所购买数量的库存总成本，单据提交审批时根据商品信息自动计算，包括退货商品的成本<br />
              有效成本指总成本除去退货商品之后的成本
            </div>
            <div class="fm-flex fm-center">
              <i class="el-icon el-icon-question fm-mr-5"></i>商品成本
            </div>
          </el-tooltip>
          <template slot-scope="scope">
            <div class="fm-flex">
              总成本：<FmAmount :amount="scope.row.itemMwAmount"></FmAmount>
            </div>
            <div class="fm-flex">
              有效成本：<FmAmount
                :amount="scope.row.itemEffectiveMwAmount"
              ></FmAmount>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="金额"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              总零售价：
              <FmAmount
                :amount="scope.row.commodityBuyingTotalAmount"
              ></FmAmount>
            </div>
            <div class="fm-flex">
              折扣金额：<FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </div>
            <div class="fm-flex">
              成交价：<FmAmount :amount="scope.row.itemAmount"></FmAmount>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="出库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            {{ "待出库 " + scope.row.toBeOutputQuantity }}<br />
            {{
              "出库中 " +
              scope.row.outputingQuantity +
              " , 已出库 " +
              scope.row.completedOutputQuantity
            }}<br />
            {{
              "退货中 " +
              scope.row.returningQuantity +
              " , 已退货 " +
              scope.row.completedReturnQuantity
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="其他费用"
      span="4"
      v-if="
        head.otherExpenseAmount > 0 ||
        (head.orderOtherExpenseList && head.orderOtherExpenseList.length > 0)
      "
    >
      <div class="fm-flex">
        其他费用金额合计：
        <FmAmount :amount="head.otherExpenseAmount"></FmAmount>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.orderOtherExpenseList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="费用金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总零售价：<FmAmount
          :amount="head.commodityBuyingTotalAmount"
        ></FmAmount
        >，优惠金额：<FmAmount :amount="head.disCountAmount"></FmAmount
        >，零售成交价：<FmAmount :amount="head.commodityBuyingAmount"></FmAmount
        >）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="其他成本" span="4">
      <el-tooltip slot="label" effect="dark" content="" placement="top-start">
        <div slot="content" style="line-height: 1.5em">
          <div style="font-weight: bold">其他成本说明</div>
          其他成本指商户在销售过程中除商品成本之外所需承担的各项额外费用，例如工人的安装服务费用、物流配送费用等<br />
          其他成本并不直接体现在销售单据的总金额上，而是在计算销售单的实际利润时，从单据所示金额中相应扣除的开支
        </div>
        <div class="fm-flex">
          <i class="el-icon el-icon-question fm-mr-5"></i>其他成本
        </div>
      </el-tooltip>
      <div class="fm-flex">
        <div
          class="fm-flex"
          v-if="
            head.otherCostAmount > 0 ||
            (head.orderOtherCostList && head.orderOtherCostList.length > 0)
          "
        >
          其他成本金额合计：
          <FmAmount :amount="head.otherCostAmount"></FmAmount>
        </div>
        <span v-fmtype="'warning'" v-else>——</span>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.orderOtherCostList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
        v-if="head.orderOtherCostList && head.orderOtherCostList.length > 0"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="成本金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="收款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          收款进度：
          <span
            v-fmtype="
              $jsTool.getFundCollectProgressType(head.fundCollectProgressEnum)
            "
          >
            {{ head.fundCollectProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待收：<FmAmount :amount="head.toBeCollectAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          收款中：<FmAmount :amount="head.collectingAmount"></FmAmount
          >，已收款：<FmAmount :amount="head.completedCollectAmount"></FmAmount
          >，收款优惠：<FmAmount
            :amount="head.collectDisCountAmount"
          ></FmAmount>
        </div>
        <div class="fm-flex">
          退款中：<FmAmount :amount="head.returningAmount"></FmAmount
          >，已退款：<FmAmount :amount="head.completedReturnAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          全部收款时间：<span
            v-fmtype="head.fullCollectTime ? '' : 'warning'"
            >{{ head.fullCollectTime || "暂无" }}</span
          >
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="出库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          出库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityOutputProgressType(
                head.commodityOutputProgressEnum
              )
            "
          >
            {{ head.commodityOutputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">待出库：{{ head.toBeOutputQuantity }}</div>
        <div class="fm-flex">
          出库中：{{ head.outputingQuantity }}，已出库：{{
            head.completedOutputQuantity
          }}
        </div>
        <div class="fm-flex">
          退货中：{{ head.returningQuantity }}，已退货：{{
            head.completedReturnQuantity
          }}
        </div>
        <div class="fm-flex">
          全部出库时间：<span v-fmtype="head.fullOutputTime ? '' : 'warning'">{{
            head.fullOutputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item
      :label="
        head.fundCollectProgressEnum.Name == 'FullCollection' ||
        head.fundCollectProgressEnum.Name == 'NoNeedCollected'
          ? '单据利润'
          : '预计利润'
      "
      span="4"
      v-if="
        head.orderApprovalStatusEnum.Name == 'Approval' &&
        $jsTool.currentUserCanSeePrice()
      "
    >
      <el-tooltip slot="label" effect="dark" content="" placement="top-start">
        <div slot="content" style="line-height: 1.5em">
          <div style="font-weight: bold">销售单利润计算方式</div>
          销售单(预计)利润 = (预计)实收金额 + 退货付款优惠 - 有效商品成本 -
          其他成本<br />
          销售单在收款完成前会使用预计收款金额计算预计利润；<br />
          收款完成之后，会使用实收金额计算单据利润
        </div>
        <div class="fm-flex">
          <i class="el-icon el-icon-question fm-mr-5"></i>
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "单据利润"
              : "预计利润"
          }}
        </div>
      </el-tooltip>
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "单据利润"
              : "预计利润"
          }}：<FmAmount :amount="head.orderProfitAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          {{
            head.fundCollectProgressEnum.Name == "FullCollection" ||
            head.fundCollectProgressEnum.Name == "NoNeedCollected"
              ? "实际收款"
              : "预计实收"
          }}：
          <FmAmount
            :amount="
              $jsTool.sum([
                head.toBeCollectAmount,
                head.collectingAmount,
                head.completedCollectAmount,
                -head.collectDisCountAmount,
              ])
            "
          ></FmAmount>
          ，
          <div class="fm-ml-10">
            <el-tooltip effect="dark" content="" placement="top-start">
              <div slot="content" style="line-height: 1.5em">
                <div style="font-weight: bold">退货付款优惠说明</div>
                关联退货单的付款优惠金额
              </div>
              <div class="fm-flex">
                <i class="el-icon el-icon-question fm-mr-5"></i>退货付款优惠：
              </div>
            </el-tooltip>
          </div>
          <FmAmount :amount="head.returnPayDisCountAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          <div>
            <el-tooltip effect="dark" content="" placement="top-start">
              <div slot="content" style="line-height: 1.5em">
                <div style="font-weight: bold">有效商品成本说明</div>
                商品总成本扣除退货商品之后的成本
              </div>
              <div class="fm-flex">
                <i class="el-icon el-icon-question fm-mr-5"></i>有效商品成本：
              </div>
            </el-tooltip>
          </div>
          <FmAmount :amount="head.effectiveMwAmount"></FmAmount>，
          <div class="fm-ml-10">其他成本：</div>
          <FmAmount :amount="head.otherCostAmount"></FmAmount>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item
      label="现结金额"
      span="4"
      v-if="
        head.settledAmount > 0 ||
        (head.fundAccountList && head.fundAccountList.length > 0)
      "
    >
      <div class="fm-flex">
        现结金额合计：
        <FmAmount :amount="head.settledAmount"></FmAmount>
      </div>
      <el-table
        class="fm-margin-top-10"
        :data="head.fundAccountList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="fundAccount"
          label="资金账户"
          width="250"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              <el-image
                style="width: 18px; height: 18px"
                fit="cover"
                class="fm-margin-right-5"
                :src="
                  $jsTool.getFundAccountImageSrc(
                    scope.row.fundAccount.fundAccountTypeEnum
                  )
                "
              ></el-image>
              {{ scope.row.fundAccount.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="现结金额"
          width="150"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.itemAmount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item
      label="纸质单据"
      span="3"
      v-if="
        head.settledAmount > 0 ||
        (head.fundAccountList && head.fundAccountList.length > 0)
      "
    >
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item
      label="收款凭证"
      span="3"
      v-if="
        head.settledAmount > 0 ||
        (head.fundAccountList && head.fundAccountList.length > 0)
      "
    >
      <OrderImageList
        :list="head.collectVoucherImageList"
        name="收款凭证图片"
      ></OrderImageList>
    </el-descriptions-item>

    <el-descriptions-item label="预收单" span="2">
      <div
        v-if="
          head.relatedPreCollectOrderList &&
          head.relatedPreCollectOrderList.length > 0
        "
      >
        <el-table
          :data="
            head && head.relatedPreCollectOrderList
              ? head.relatedPreCollectOrderList
              : []
          "
          :row-key="
            (row) => {
              return row.id + row.lastEditTime;
            }
          "
          stripe
          max-height="300px"
        >
          <el-table-column
            prop="preCollectOrder.orderNo"
            label="预收单单号"
            min-width="200"
            align="center"
            header-align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="orderAmount"
            label="预收单金额"
            width="150"
            align="center"
            header-align="center"
            sortable
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.preCollectOrder.orderAmount"
              ></FmAmount>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span v-fmtype="'warning'" v-else>未选择预收单</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="1">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="拓展字段" span="3">
      <div v-if="head.extFieldValueList && head.extFieldValueList.length > 0">
        <div v-for="(item, index) in head.extFieldValueList" :key="index">
          {{
            item.label + "：" + (item.value == null ? "-" : item.value) + ";"
          }}
        </div>
      </div>
      <div v-fmtype="'warning'" v-else>—</div>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = { ...newVal, headVo: newVal.head };
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.headVo
        ? this.showOrderInfo.headVo
        : {};
    },
    itemList() {
      if (this.showOrderInfo && this.showOrderInfo.itemList) {
        let arr = this.showOrderInfo.itemList;
        // 分离有saleSuitId和无saleSuitId的项
        let withSuit = arr.filter((item) => item.saleSuitId);
        let withoutSuit = arr.filter((item) => !item.saleSuitId);
        // 对有saleSuitId的项进行排序
        withSuit.sort((a, b) => {
          if (a.saleSuitId < b.saleSuitId) return -1;
          if (a.saleSuitId > b.saleSuitId) return 1;
          return a.itemNo - b.itemNo; // 同一saleSuitId按itemNo排序
        });

        // 对无saleSuitId的项进行排序
        withoutSuit.sort((a, b) => a.itemNo - b.itemNo);

        // 合并两个数组
        let res = [...withSuit, ...withoutSuit];
        res.forEach((item, index) => {
          item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
        });
        return res;
      }
      return [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:SaleOrder:NeedApproval",
        "Order:SaleOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.saleOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ((columnIndex == 1 || columnIndex == 2) && row.saleSuitId) {
        let list = this.itemList
          .filter((d) => d.saleSuitId && d.saleSuitId == row.saleSuitId)
          .sort((a, b) => {
            return a.itemNo - b.itemNo;
          });
        if (list[0].itemNo == row.itemNo) {
          return {
            rowspan: list.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/SaleOrderInfo.vue